export default __webpack_public_path__ + "static/media/icono-emergencia-extranjero.469d6820.svg";